import { GameProfil } from '../../domain/gameProfil/GameProfil';
import { RestGame, toGame } from '../game/RestGame';
export interface RestGameProfil {
  game: RestGame;
}

export function toGameProfil(restGameProfil: RestGameProfil) {
  return new GameProfil(toGame(restGameProfil.game), undefined);
}
